import { render, staticRenderFns } from "./error-aggregator.vue?vue&type=template&id=1aa553ac&scoped=true&"
import script from "./error-aggregator.vue?vue&type=script&lang=ts&"
export * from "./error-aggregator.vue?vue&type=script&lang=ts&"
import style0 from "./error-aggregator.vue?vue&type=style&index=0&id=1aa553ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa553ac",
  null
  
)

export default component.exports